import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isAgent } from '../../constants/roles';
import { SELLER_PAGE_VIEWS, workspacePath } from '../agent/workspace/paths';

/**
 * HomeownerRoute - a property's page at its seller URL (/my-property/:propertyId and the pages
 * under it). An agent opens the same property at their own URL (docs/agent-feature-audit.md
 * section 15): whoever sent them here (a link, the chat, a notice), they land on the agent's page
 * for `page` ('overview', 'details', 'media', 'similar', 'marketing'; the selling journey, the
 * homeowner's own, opens the property), with the same query (an open panel). Only an agent with
 * the role: someone still finishing onboarding has no agent pages yet (the agent area sends them
 * back to onboarding), so a property they added as a seller stays open to them here. Adding a
 * property (/my-property/new) has its own route (NewPropertyRoute).
 */
const HomeownerRoute = ({ page = 'overview', children }) => {
  const { propertyId } = useParams();
  const location = useLocation();
  const { currentUser } = useAuth();
  if (isAgent(currentUser)) {
    const view = SELLER_PAGE_VIEWS[page] || 'overview';
    return <Navigate to={`${workspacePath(propertyId, view)}${location.search}`} replace />;
  }
  return children;
};

export default HomeownerRoute;
